import { render, staticRenderFns } from "./TchHeader.vue?vue&type=template&id=c6861d14&scoped=true"
import script from "./TchHeader.vue?vue&type=script&lang=js"
export * from "./TchHeader.vue?vue&type=script&lang=js"
import style0 from "./TchHeader.vue?vue&type=style&index=0&id=c6861d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6861d14",
  null
  
)

export default component.exports